/* AMOR search suggestions. Every search form (header, mobile menu, search page, 404) gets a dropdown with
   matching categories and products while typing. The HTML comes from sections/am-predictive-search via
   Shopify's predictive search; without JS the forms simply submit to /search. */
(() => {
  const forms = [...document.querySelectorAll('form[role="search"]')].filter((f) => f.querySelector('input[name="q"]'));
  if (!forms.length || !window.fetch) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cache = new Map();

  forms.forEach((form, n) => {
    const input = form.querySelector('input[name="q"]');
    const box = document.createElement('div');
    box.className = 'am-sugg';
    box.id = 'am-sugg-' + n;
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    form.append(box);
    form.classList.add('am-sugg-host');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');

    let timer = 0, seq = 0, active = -1;
    const options = () => [...box.querySelectorAll('[role="option"]')];
    const open = (on) => {
      box.hidden = !on;
      input.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) { active = -1; input.removeAttribute('aria-activedescendant'); }
    };
    const mark = (i) => {
      const opts = options();
      opts.forEach((o, k) => o.classList.toggle('is-active', k === i));
      active = i;
      if (opts[i]) { opts[i].id = opts[i].id || box.id + '-o' + i; input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    };
    const render = (html) => {
      box.innerHTML = html;
      active = -1;
      open(!!html.trim() && document.activeElement === input);
    };
    const load = () => {
      const q = input.value.trim();
      if (q.length < 2) { open(false); return; }
      if (cache.has(q)) { render(cache.get(q)); return; }
      const my = ++seq;
      form.classList.add('is-loading');
      // 14.10.2026: unavailable products are no longer pushed last by Shopify ("sogno" listed four other beds, which
      // Shopify finds by meaning, above the sold-out SOGNO itself). Shopify returns up to 10 by relevance; the
      // section puts products named like the query first and in-stock before sold-out within each group, shows 6.
      const url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=show&section_id=am-predictive-search';
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('.am-sugg__in');
          const html = inner ? inner.outerHTML : '';
          cache.set(q, html);
          if (my === seq) render(html);
        })
        .catch(() => {})
        .finally(() => { if (my === seq) form.classList.remove('is-loading'); });
    };

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(load, 160); });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) open(true); });
    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      const opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(Math.min(active + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(active - 1, -1)); }
      else if (e.key === 'Enter' && opts[active]) { e.preventDefault(); location.href = opts[active].href; }
      else if (e.key === 'Escape') { e.stopPropagation(); open(false); }
    });
    /* Closed by a tap/click anywhere else, Esc or Tab. Not on blur: on phones a tap on a suggestion
       blurs the field before the link receives the click. */
    document.addEventListener('pointerdown', (e) => { if (!form.contains(e.target)) open(false); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Tab') open(false); });
  });
})();
